export default __webpack_public_path__ + "static/media/Prancheta 1.efa936d9.png";